import React from "react";

export default function Transporte({ bgColor }) {
  return (
    <>
      <section
        id="transporte"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <section className="team-member-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 col-md-8">
                <div className="section-heading text-center mb-4">
                  <h2>Transporte</h2>
                  <p className="lead">
                    Plusmar, cuya flota es la más moderna y grande del país,
                    cuentan con sistema GPS para controlar la ubicación y
                    velocidad con ESP para garantizar la seguridad.
                  </p>
                  {/* <p className="lead">
                    Aire y tierra cobertura en todos lados
                  </p> */}
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/tierra2.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">PlusMar</h5>
                    <h6>Tierra</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white"></ul>
                    <a
                      href="https://www.plusmar.com.ar/es"
                      target="_blank"
                      without
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ir a la web
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
